import React from 'react';

const LazyTeamImage= React.lazy(() =>
  import(/* webpackChunkName: "TeamImage */ './teamImage')
);

const TeamImage= (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyTeamImage{...props} />
  </React.Suspense>
);

export default TeamImage